import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import Switch from 'react-switch';
import {connect} from 'react-redux';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {fixedToWithoutRound, getTokenDecimals} from '../helpers/Utils';
import {Colxx} from '../components/common/CustomBootstrap';
import {baseTokenSymbol, reactTableText} from '../constants/configs';
import BankDepositForm from '../containers/BankDepositForm';
import ModalManager from '../components/modal/ModalManager';
import {keyBy, reduce, values, omitBy, filter, map} from 'lodash';
import ToolTip from '../components/ToolTip';
import Rbac from '../components/Rbac';

class Wallets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideZeroBalances:
        !!(localStorage.getItem('hideZeroBalances') &&
          localStorage.getItem('hideZeroBalances') === '1'),
    };
  }

  openBankDepositModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Top-up Balance'),
      body: this.renderBankDepositForm(),
    });
  };

  renderBankDepositForm = () => {
    const {userId, updateTransactions, fetchWallets, firstName, lastName} = this.props;
    return (
      <BankDepositForm
        userId={userId}
        firstName={firstName}
        lastName={lastName}
        updateWallets={fetchWallets}
        updateTransactions={updateTransactions}
      />
    );
  };

  getTotalCost = wallets => {
    const tokens = keyBy(this.props.tokens, 'symbol');
    const result = reduce(wallets, (sum, wallet) => {
      const walletValue = (Number(wallet.balance) + Number(wallet.reservedBalance)) * tokens[wallet.token].convertRateInBase;
      return sum + walletValue;
    }, 0);
    return fixedToWithoutRound(result, getTokenDecimals(baseTokenSymbol));
  };

  getColumns = (t, tokens) => [
    {
      accessor: 'token',
      Cell: props => <img
        className="avatar-mini"
        alt={tokens[props.value] ? tokens[props.value].name : props.value}
        src={tokens[props.value] ? tokens[props.value].logoUrl : null}
      />,
      width: 60,
    },
    {
      Header: t('Name'),
      accessor: 'token',
      Cell: props => <span>{tokens[props.value] ? tokens[props.value].localeName : props.value}</span>,
    },
    {
      Header: t('Balance'),
      accessor: 'balance',
      Cell: props => <span>{fixedToWithoutRound(props.value, getTokenDecimals(props.original.token))}</span>,
    },
    {
      Header: t('Reserved Balance'),
      accessor: 'reservedBalance',
      Cell: props => <span>{fixedToWithoutRound(props.value, getTokenDecimals(props.original.token))}</span>,
    },
    {
      Header: t('Affiliate Profit'),
      accessor: 'affiliateProfit',
      Cell: props => <span>{fixedToWithoutRound(props.value, getTokenDecimals(props.original.token))}</span>,
    },
    {
      Header: `${t('Value')} (${t(baseTokenSymbol)})`,
      accessor: 'value',
      Cell: props => <span>
        {tokens[props.original.token] ?
          fixedToWithoutRound(props.value, getTokenDecimals(baseTokenSymbol)) : null
        }
      </span>,
    },
    {
      Header: t('Actions'),
      accessor: 'token',
      width: 60,
      Cell: props => {
        if (props.value === baseTokenSymbol) {
          return (
            <div>
              <ToolTip id={`top-up_${props.value}`} text={t('Top-up Balance')}>
                <i className="icon-Folder-Add text-large text-info font-weight-semibold cursor-pointer"
                   onClick={this.openBankDepositModal}/>
              </ToolTip>
            </div>
          );
        }
        return null;
      },
      show: Rbac.hasPermission('create_user-bank-deposit'),
    }
  ];

  getWalletValue = wallet => {
    const tokens = keyBy(this.props.tokens, 'symbol');
    const {balance, reservedBalance, token} = wallet;
    return ((Number(balance) + Number(reservedBalance))) * tokens[token].convertRateInBase;
  };

  sortedWallets = list => {
    const {hideZeroBalances} = this.state;
    const wallets = keyBy(list, 'token');
    const baseTokenWallet = {...wallets[baseTokenSymbol], value: this.getWalletValue(wallets[baseTokenSymbol])};
    let withoutBaseToken = map(values(omitBy(wallets, obj => obj.token === baseTokenSymbol)), obj => {
      return {...obj, value: this.getWalletValue(obj)};
    });
    if (hideZeroBalances) {
      withoutBaseToken = filter(withoutBaseToken, obj => obj.value !== 0);
    }
    withoutBaseToken.sort(function(a, b){return b.value - a.value;});
    return [baseTokenWallet, ...withoutBaseToken];
  };

  onChangeWalletsStatus = enabled => {
    this.setState({
      hideZeroBalances: enabled,
    });
    localStorage.setItem('hideZeroBalances', enabled ? '1' : '0');
  };

  render() {
    const {hideZeroBalances} = this.state;
    const {t, tokens, wallets} = this.props;
    const newTokens = keyBy(tokens, 'symbol');
    let data = wallets && wallets.length ? this.sortedWallets(wallets) : [];
    const totalCost = data.length ? this.getTotalCost(data) : 0;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-4">
                {t('Wallets')}
                <span className="text-info text-one">
                  {` (${t('Total Cost')}: ${totalCost} ${t(baseTokenSymbol)})`}
                </span>
              </CardTitle>
              <div className="d-flex flex-row justify-content-end align-items-center mb-3">
                <Switch
                  className="ltr"
                  onChange={this.onChangeWalletsStatus}
                  checked={hideZeroBalances}
                  uncheckedHandleIcon={false}
                  checkedIcon={false}
                  height={20}
                  width={45}
                />
                <div className="text-black ml-2">{t('Hide empty wallets')}</div>
              </div>
              <ReactTable
                manual
                className="-highlight"
                data={data}
                sortable={false}
                resizable={true}
                showPagination={false}
                columns={this.getColumns(t, newTokens)}
                defaultPageSize={data.length}
                loading={!wallets}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

const mapStateToProps = ({general}) => ({
  tokens: general.tokens,
});

export default connect(mapStateToProps)(withTranslation()(Wallets));
